import { Route } from "@angular/router"
import { CraneListComponent } from "./ui/crane-list/crane-list.component"
import {LayoutComponent} from "../../core/layout/layout.component";

const craneRoutes: Route[] = [
    {
      path: 'cranes',
      component: LayoutComponent,
      children: [
        {
          path: '',
          component: CraneListComponent
        }
      ]
    }
  ]

export default craneRoutes
